exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-7fd4a{border-radius:100%;height:4.4rem;margin:2.4rem 0 1.8rem 0;width:4.4rem}.icon-7fd4a.warn-25c73{background-color:#ffa700;color:#fff}.text-a25c4{max-width:50.5rem}", ""]);

// Exports
exports.locals = {
	"icon": "icon-7fd4a",
	"warn": "warn-25c73",
	"text": "text-a25c4"
};